
import Vue from "vue";
import API from "@/api/API";
import store from "@/store";
import { Dictionary } from "vue-router/types/router";
import filters from "../config/filters.json";
import tablePagination from "@/mixins/table-pagination";
import tableFilters from "@/mixins/table-filters";
import { parseArrayParams } from "@/services/helpers";
import rules from "@/services/helpers/validation-rules";

import SettingsDialog from "../components/SettingsDialog.vue";
import canDeleteFields from "../config/order-delete.json";
import HeadersToggle from "@/modules/orders/components/HeadersToggle.vue";
import EditSpecialists from "@/modules/orders/components/EditSpecialists.vue";
import FilterField from "@/modules/orders/components/FilterField.vue";
import debounce from "lodash/fp/debounce";
import permissions from "@/modules/orders/config/actions-fields.json";
import actionButtons from "@/modules/orders/config/actions-buttons.json";
import ActionsModal from "@/modules/orders/components/ActionsModal.vue";
import ConfirmDialog from "@/components/dialogs/ConfirmDialog.vue";

export default Vue.extend({
  name: "Requests",

  components: {
    ConfirmDialog,
    FilterField,
    EditSpecialists,
    SettingsDialog,
    HeadersToggle,
    ActionsModal
  },

  mixins: [tablePagination, tableFilters],

  data: () => ({
    debounce,
    actionButtons,
    filters,
    canDeleteFields,
    rules,
    dialog: false,
    subdivisionDialog: false,
    parseArrayParams,
    debounced: null as any,
    filter: {} as Dictionary<any>,
    headers: [] as Array<HeadersInterface>,
    visibleHeaders: [] as Array<HeadersInterface>,
    items: [] as Array<any>,
    loading: false as boolean,
    loadingManagers: false as boolean,
    showMenu: false,
    x: 0,
    y: 0,
    selectedServices: [] as any,
    filterService: 'default' as string,
    selects: {
      statuses: [] as Array<any>,
      managers: [] as Array<any>,
      languages: [
        { value: "ro", text: "RO" },
        { value: "en", text: "EN" },
        { value: "ru", text: "RU" }
      ] as Array<SelectComponentInterface>,
      documentTypes: [] as Array<SelectComponentInterface>,
      sources: ["client", "operator"] as Array<string>,
      purposeOfUse: [] as Array<SelectComponentInterface>,
      goods: [] as Array<SelectComponentInterface>,
      branches: [] as Array<SelectComponentInterface>,
      subdivisions: [] as Array<SelectComponentInterface>,
      serviceTypes: [] as Array<SelectComponentInterface>,
      countries: [] as Array<SelectComponentInterface>,
      currencies: [] as Array<SelectComponentInterface>,
      specialists: [] as Array<SelectComponentInterface>,
      clientTypes: [] as Array<SelectComponentInterface>,
      reportTypes: [] as Array<SelectComponentInterface>,
    },
    statuses: {
      active: "1,2,3",
      archive: "4,5,6,7"
    } as any,
    lang: store.getters["localization/getCurrent"],
    selectedItem: {} as any,
    isUploadFile: false as boolean,
    isPrintDialog: false as boolean,
    isLoadedSelectsData: false as boolean,
    showConfirm: false as boolean,
    managerId: null as null | number,
    orderId: null as null | number,
    activeFilter: "active" as string,
    showEditSpecialists: false as boolean,
    selectedText: "" as string,
    marks: [] as Array<any>,
    menu: [] as Array<any>,
    loadingServices: false as boolean,
    exportMessage: '',
    ordersCount: {
      dispatcher: 0,
      active: 0,
      archive: 0
    } as any,
    newBranchModel: null as any,
    newSubdivisionModel: null as any,
    showPrintDialog: false as boolean,
    windowSize: {
      x: 0
    }
  }),

  watch: {
    showFilters: {
      immediate: true,
      handler() {
        if (!this.isLoadedSelectsData) {
          this.getSelectsData();
        }
      }
    },
    'filter.service_types': function (newVal, oldVal) {
      this.redrawFilters(newVal);
    },
    'filter.branches': function () {
      this.loadSpecialists();
    },
    'filter.subdivisions': function () {
      this.loadSpecialists();
    },
    selectedServices(val, oldVal) {
      if (this.debounced) {
        this.debounced.cancel();
      }

      if (oldVal.length) {
        this.loadingServices = true;
      }

      this.debounced = this.debounce(300, () => {
        if (oldVal.length) {
          setTimeout(() => {
            this.loading = true;

            this.setServicesFilter();
            this.loading = false;
            this.loadingServices = false;
          }, 500);
        }
      });

      this.debounced();
    }
  },

  computed: {
    canSwitchService() {
      const allowedRoles = [
        "admin",
        "chairman",
        "vice_president",
        "subdivision_head",
        "specialist",
        "specialist_ata",
        "expert"
      ];
      return this.currentRole && allowedRoles.includes(this.currentRole.alias);
    },
    currentRole(): any {
      return this.$store.getters["user/currentRole"];
    },
    isSpecialist() {
      return this.currentRole?.alias === "specialist";
    },
    settingsModalLabel() {
      if (this.isUploadFile && !this.isPrintDialog) {
        return this.$t("orders.form.fields.upload_guarand");
      }
      if (!this.isUploadFile && !this.isPrintDialog) {
        return this.$t("orders.form.fields.confirm_tax");
      }
      return "";
    },
    availableFilters() {

      const allArrays: any[] = (this.filters as any)[
          this.currentRole?.alias === 'specialist_ata' ? 'ata' : this.filterService
          ] || [];

      const commonItems: any[] = [];

      const currentRole = this.currentRole;
      const allowedRoles = ['subdivision_head', 'specialist_ata'];

      for (const item of allArrays) {
        if (item.value === 'service_types' && (!currentRole || !allowedRoles.includes(currentRole.alias))) {
          continue;
        }

        if (
            this.numberOfAppearance(allArrays, item.value) > 0 &&
            !commonItems.some(({ value }: any) => value === item.value)
        ) {
          commonItems.push(item);
        }
      }

      return commonItems;

    },
    user() {
      return this.$store.getters["user/info"];
    },
    showDispatcherBtn() {
      return this.user?.roles.some((item: any) => item?.alias === "dispatcher");
    },
    isAtaFilterSelected() {
      const selected = this.selectedServices.map(
        (item: any) => item.alias === "ata"
      );
      const toCompare = [true];
      return (
        selected.length == toCompare.length &&
        selected.every((element: any, index: any) => {
          return element === toCompare[index];
        })
      );
    },
    correctManagers() {
      if (this.isAtaFilterSelected) {
        return this.selects.managers.filter((item: any) => {
          return item.id === 206 || item.id === 76 || item.id === 117;
        });
      }
      return this.selects.managers;
    }
  },

  async mounted() {
    this.onResize();
    await store.dispatch("preloader/showGlobal");
    try {
      const params = {
        filter: this.$route.query,
        page: {
          number: this.$route.params.page,
          size: 50
        }
      };

      if (!params.filter["status"]) {
        params.filter["status"] = "1,2,3,11,12,13";
      }

      const statusFilter = this.$route.params["status"];
      if (statusFilter) {
        if (statusFilter === this.statuses.archive) {
          this.activeFilter = "archive";
          params.filter["status"] = this.statuses.archive;
        } else if (statusFilter === this.statuses.active) {
          this.activeFilter = "active";
          params.filter["status"] = this.statuses.active;
        } else {
          this.activeFilter = "";
        }
      }

      this.selects.serviceTypes = await this.$API
        .serviceTypes()
        .getListWithFilters();

      if (params.filter.service_types) {
        this.selectedServices = (params.filter.service_types as any)
          .split(",")
          .map((item: any) => {
            const service = this.selects.serviceTypes.find(
              (value: any) => value.id === Number(item)
            );
            if (service) {
              return service;
            }
          })
          .filter((item: any) => item);
      } else {
        this.selectedServices = this.selects.serviceTypes;

        params.filter.service_types = this.selectedServices
          .map((item: any) => item.id)
          .join(",");
      }

      const response = await this.$API.orders().getData(params);

      this.ordersCount = await API.orders().getOrdersCount({
        service_types: params.filter.service_types
      });
      let marks: any = [];

      const isReportData = response.items.data.length > 0 &&
          (!response.items.data[0].id || response.items.data[0].report_type || response.items.data[0].orders_count);

      if (response.items.data.length && !isReportData) {
        marks = await API.orders().getMarks(
          response.items.data.map((item: any) => item.id)
        );
      }

      this.marks = marks;
      this.setServerResponse(response);
      this.setFilters(params.filter);
      await this.setDefaultBranchAndSubdivisions();
    } catch (e) {
      await store.dispatch("alert/showError", e.message);
    }
    await store.dispatch("preloader/hideGlobal");
  },

  methods: {
    redrawFilters(newVal: any) {
      if (newVal === 1) {
        this.filterService = 'ata';
      } else {
        this.filterService = 'default';
      }
    },
    async setDefaultBranchAndSubdivisions() {
      if (this.filter.branches?.length) return;
      const defaultBranch = this.selects.branches.find(b => b.value === 8);
      if (!defaultBranch) return;

      this.filter.branches = defaultBranch.value;

      await this.loadSubdivisions();

      if (this.filter.subdivisions?.length) return;

      const defaultSubdivision = this.selects.subdivisions.find(s => s.value === 14);
      if (defaultSubdivision) {
        this.filter.subdivisions = defaultSubdivision.value;
      }
    },
    setServicesFilter() {
      this.filter.service_types = this.selectedServices
        .map((item: any) => {
          const service = this.selects.serviceTypes.find(
            ({ id }: any) => id === item.id
          );

          return (service as any)?.id;
        })
        .filter((item: any) => item);
      this.loading = false;
      this.loadingServices = false;
      this.debounced.cancel();
      this.updateData();
    },
    setAllServices() {
      this.selectedServices = this.selects.serviceTypes.map(
        (item: any) => item
      );
    },
    numberOfAppearance(array: any, value: any): number {
      return array.reduce((count: number, item: any) => {
        if (value === item.value) {
          return count + 1;
        }

        return count;
      }, 0);
    },
    toggleSpecialists(event: boolean, orderId = null) {
      if (orderId) {
        this.orderId = orderId;
      }
      this.showEditSpecialists = event;
    },
    isArchive(type: string) {
      return this.activeFilter === type;
    },

    async exportToExcel() {

      const excelResponse = await this.$API.orders().getExcel({
        filter: this.parseArrayParams(this.filter),
        selectedColumns: this.visibleHeaders
      });

      const contentType = excelResponse.type;

      if (contentType === 'application/json') {
          return;
      }

      const url = window.URL.createObjectURL(excelResponse);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'orders.xlsx');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    },

    async setFilterStatus(type: string) {
      if (type === "dispatcher") {
        this.filter = { mode: type };
      } else {
        this.filter.status = this.statuses[type];
        delete this.filter.mode;
      }

      await this.applyFilters();

      this.setFilters(this.filter);
      this.activeFilter = type;
    },
    canDeleteOrder(alias: string): boolean {
      return this.canDeleteFields.subject.includes(alias);
    },
    async loadData(): Promise<void> {
      this.loading = true;
      try {
        const response = await this.$API.orders().getData({
          filter: this.parseArrayParams(this.filter),
          page: this.pagination,
          sort: this.getSortParams()
        });

        let service_types;
        if (this.filter.service_types) {
          service_types = this.parseArrayParams(this.filter).service_types;
        }

        this.ordersCount = await this.$API.orders().getOrdersCount({
          service_types
        });

        const isReportData = response.items.data.length > 0 &&
            (!response.items.data[0].id || response.items.data[0].report_type || response.items.data[0].orders_count);

        if (response.items.data.length && !isReportData) {
          this.marks = await API.orders().getMarks(
            response.items.data.map((item: any) => item.id)
          );
        } else {
          this.marks = [];
        }

        await this.setServerResponse(response);
      } catch (e) {
        await this.$store.dispatch("alert/showError", e.message);
      }
      this.loading = false;
      this.showConfirm = false;
    },
    async deleteRow(id: number): Promise<void> {
      this.loading = true;
      try {
        await this.$API.orders().delete(id);
        await this.$store.dispatch(
          "alert/showSuccess",
          this.$t("global_alert.successful_removal")
        );
        await this.loadData();
      } catch (e) {
        await this.$store.dispatch("alert/showError", e.message);
      }
      this.loading = false;
    },
    setFilters(filter: Dictionary<string | (string | null)[]>): void {
      const newFilters = this.getAvailableFilters(filter);
      this.filter = this.parseArrayFilter(newFilters);
      this.changeActiveFilters();
    },
    resetFilters(): void {
      this.filter = {
        status: this.statuses.active,
        service_types: this.filter.service_types
      };
      this.activeFilter = "active";
      try {
        this.$router.push(
          `/${this.$route?.meta?.module}/page/${this.pagination.number}`
        );
        this.setFilters(this.filter);
        this.applyFilters();
        this.showFilters = false;
      } catch {
        Promise.resolve();
      }
    },
    can(action: string, subject: string): boolean {
      return (
        permissions.actions.includes(action) &&
        !permissions.subject.includes(subject)
      );
    },
    parseArrayFilter(filter: any): any {
      const arrayFilter = [
        "language",
        "source",
        "document_type",
        "client_type",
        "valid_period",
        "release_date"
      ];

      const integerFields = [
        "branches",
        "subdivisions",
        "service_types",
        "managers",
        "status",
        "country",
        "purposes"
      ];

      const stringFields = [
        "report_type"
      ];

      for (const key of Object.keys(filter)) {
        if ([...integerFields, ...arrayFilter, ...stringFields].includes(key)) {
          if (filter[key] && !Array.isArray(filter[key])) {
            filter[key] = filter[key]?.split(",");

            if (integerFields.includes(key)) {
              filter[key] = filter[key].map((item: string) => Number(item));
            }
          }
        }
      }

      return filter;
    },
    setServerResponse({ items, headers }: any) {
      this.headers = [
        ...headers,
        {
          text: "",
          value: "actions",
          width: "80px",
          align: "center",
          sortable: false
        }
      ];
      this.changeHeaders();
      const isReportData = items.data.length > 0 &&
          (!items.data[0].id || items.data[0].report_type || items.data[0].orders_count);

      if (isReportData) {
        // For report data, don't add highlights or try to process marks
        this.items = items.data;
      } else {
        // For regular order data, process highlights and marks as usual
        this.items = items.data.map((item: any) => {
          const matchingItem = this.marks.find(
              (mark: any) => mark.order_id === item.id
          );
          const descriptions: any = {
            NEW_ORDER: this.$t("orders.new-order"),
            UPDATE_ORDER: this.$t("orders.update-order"),
            CHANGE_ORDER_SPECIALIST: this.$t("orders.specialist-reassign"),
            DEADLINE_FOR_ISSUE: this.$t("orders.order-dead_line")
          };

          return {
            ...item,
            highlight: matchingItem
                ? {
                  ...matchingItem,
                  description: descriptions[matchingItem.event_type]
                }
                : null
          };
        });
      }

      this.totalItems = items.total;
    },
    showContextMenu(e: any, item: any) {
      this.selectedItem = item.item;
      e.preventDefault();
      this.showMenu = false;
      this.x = e.clientX;
      this.y = e.clientY;
      this.showMenu = true;
    },
    async loadSubdivisions(): Promise<void> {
      try {
        const response = await this.$API
          .subdivisions()
          .getList({ filter: { branches: this.filter.branches } });
        this.selects.subdivisions = response.items;
      } catch (e) {
        await this.$store.dispatch("alert/showError", e.message);
      }
    },
    async loadSpecialists(): Promise<void> {
      try {
        if (!this.filter.subdivisions) {
          return;
        }

        const params = {
          filter: {
            subdivision: this.filter.subdivisions
          }
        };

        this.selects.specialists = await this.$API
            .users()
            .getSpecialistsList(params);
      } catch (e) {
        await this.$store.dispatch("alert/showError", e.message);
      }
    },
    async close(): Promise<void> {
      this.selectedItem = null;
      await this.loadData();
    },
    async openSettings(item: any): Promise<void> {
      this.selectedItem = item;
      this.showPrintDialog = true;
      await this.$store.dispatch("dialog/show");
    },
    async openPrintDialog(item: any): Promise<void> {
      this.selectedItem = item;
      this.showPrintDialog = true;
      //await this.$store.dispatch("dialog/show");
    },
    setFilter(field: string) {
      if (typeof this.filter[field] === "string") {
        this.filter[field] = this.filter[field].split(",");
      }
    },
    async getSelectsData(): Promise<void> {
      const [
        statuses,
        purposeOfUse,
        branches,
        subdivisions,
        documentTypes,
        managers,
        countries,
        currencies
      ] = await Promise.all([
        this.$API.orders().getStatuses(),
        this.$API.purposeOfUse().getList(),
        this.$API.branches().getList(),
        this.$API.subdivisions().getList(),
        //todo fix this
        this.$API.orders().getCardTypes(1),
        this.$API.users().getSpecialists(),
        this.$API.orders().getCountries(),
        this.$API.currency().getList()
      ]);

      this.selects.statuses = statuses;
      this.selects.purposeOfUse = purposeOfUse;
      this.selects.subdivisions = subdivisions.items;
      this.selects.branches = branches.items;
      this.selects.documentTypes = documentTypes.items;
      this.selects.managers = managers;
      this.selects.countries = countries.items;
      this.selects.currencies = currencies.items;

      this.selects.clientTypes = [
        { text: String(this.$t("orders.form.fields.client_type_physical")), value: "physical" },
        { text: String(this.$t("orders.form.fields.client_type_juridical")), value: "juridical" }
      ];

      this.selects.reportTypes = [
        { text: String(this.$t("orders.form.fields.per_agent")), value: "per_agent" },
        { text: String(this.$t("orders.form.fields.per_service")), value: "per_service" },
      ];

      this.isLoadedSelectsData = true;
    },
    changeHeaders() {
      this.visibleHeaders = this.headers;
    },
    canView(item: any, service: string): boolean {
      return (
        item &&
            item.service_type &&
        (this.actionButtons as any)[item.service_type.alias] &&
        (this.actionButtons as any)[item.service_type.alias].includes(service)
      );
    },
    getStyles(item: any) {
      if (!item.status) {
        return '';
      }

      if (item.status?.alias === "checked") {
        return "CHECKED_ORDER";
      }

      return item.highlight?.event_type;
    },
    makeAsRead(value: any) {
      if (!value.id || !value.highlight) {
        return;
      }

      const item = this.items.find((item: any) => item.id === value.id);
      if (item && item.highlight) {
        item.highlight.event_type = "checked";
      }

      if (this.selectedItem && this.selectedItem.highlight) {
        this.selectedItem.highlight.event_type = "checked";
      }
    },
    async updateData(): Promise<void> {
      this.loading = true;
      // this.setFilters(this.filter);
      await this.applyFilters();

      this.loading = false;
    },
    onResize() {
      this.windowSize = { x: window.innerWidth };
    }
  }
});
